import { dateOnly, idOf, today } from './transferModel.mjs';

const isDate = value => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return false;
  const date = new Date(`${value}T00:00:00Z`);
  return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value;
};

// getSeasonDates peut renvoyer des Date locales : ne pas afficher la veille
// en passant par toISOString() pour remplir un input de type date.
const inputDate = value => {
  if (isDate(value)) return value;
  if (!value) return '';
  const date = value instanceof Date ? value : new Date(value);
  return Number.isFinite(date.getTime()) ? dateOnly(date) : '';
};

export function getRosterDateDefaults(season, getSeasonDates, referenceDate = today()) {
  const seasonId = idOf(season);
  if (!seasonId) return { startDate: '', endDate: '' };
  const bounds = getSeasonDates?.(seasonId) || {};
  // IDs annuels (2026) et saisons à cheval sur deux années (2026/2027).
  const year = /^(\d{4})(?:[/-]\d{4})?$/.exec(seasonId)?.[1];
  return {
    startDate: year === referenceDate.slice(0, 4) ? referenceDate : inputDate(bounds.startDate),
    endDate: inputDate(bounds.endDate),
  };
}

export function getRosterDateErrors({ startDate, endDate }) {
  const errors = {
    startDate: isDate(startDate) ? '' : 'Renseignez une date de début valide.',
    endDate: isDate(endDate) ? '' : 'Renseignez une date de fin valide.',
  };
  if (!errors.startDate && !errors.endDate && startDate > endDate) {
    errors.endDate = 'La date de fin doit être égale ou postérieure à la date de début.';
  }
  return errors;
}

export function buildRosterSearchFilters(filters) {
  const error = Object.values(getRosterDateErrors(filters)).find(Boolean);
  if (error) throw new Error(error);
  return {
    provider: filters.provider, discipline: filters.discipline, season: filters.season,
    competition: filters.competition, teams: idOf(filters.team),
    // Même convention que les dates saisies dans Filters.js (GetPlayers).
    startDate: new Date(`${filters.startDate}T00:00:00Z`),
    endDate: new Date(`${filters.endDate}T00:00:00Z`),
  };
}

// Après enregistrement, conserver le même critère de chevauchement que le GET.
export function isPlayerInRosterPeriod(player, context) {
  const memberships = player.teamsSeason || [];
  if (!memberships.length) return (player.teams || []).some(team => idOf(team) === idOf(context.team));
  return memberships.some(membership => idOf(membership.team) === idOf(context.team)
    && membership.startDate && dateOnly(membership.startDate) <= context.endDate
    && (!membership.endDate || dateOnly(membership.endDate) >= context.startDate));
}
